import { Role } from '../app/model/enum/role';

export function getDefaultLandingPageByRole(role: Role): string {
  switch (role) {
    case Role.CASHIER:
      return '/registers/point-of-sales';
    case Role.SUPER_ADMIN:
      return '/companies';
    case Role.ADMIN:
    case Role.MANAGER:
      return '/dashboard';
    case Role.KITCHEN:
      return '/kitchen/live-orders';
    default:
      return '/';
  }
}
